/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Consumption_HeadlineInputs */



/**
* | output |
* | --- |
* | "Track your energy consumption" |
*
* @param {Go_Further_Consumption_HeadlineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_consumption_headline = /** @type {((inputs?: Go_Further_Consumption_HeadlineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Consumption_HeadlineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Track your energy consumption")
	return /** @type {LocalizedString} */ ("Suivez vos consommations d'énergie")
});